import React, { useEffect, useState, Fragment, useRef } from 'react';
import { Card, Col, Container, Form, Row, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { serviceGetCfgForm, serviceGetGestionImplicado, serviceGetImplicados, serviceRecepcionar } from '../../api/api-recuperacion-cobro';
import CartaCobro from './carta-cobro';
import { useFormik } from 'formik'
import { validationSchemasRecuperacionCobro } from '../../common/validation-Schemas-recuperacion-cobro';
import { Auth, LoadingComponent } from 'recupero-comunes'
import { formatoMonto, getBase64, resetFormatoMonto, resetFormatoMontoSinPunto } from '../../common/Formatos';
import { CarpetaDigitalComponent } from 'reccol-caso-general';
import BitacoraGestion from '../bitacora-gestion-recuperador';
import { useLocation, useNavigate } from 'react-router-dom';
import { obtenerDatosLlaves} from '../../store/actions/encargado-cia-action'
import {  useDispatch } from 'react-redux';
import Mensajes from '../mensajes'

const FormPrincipal = ({ idCaso, idOrgCaso }) => {
    const dispatch=useDispatch()
    const history = useNavigate();
    const { state } = useLocation();
    const fileRef = useRef();
    const { rutUsuario } = Auth.currentUser();
    const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoCias'));
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);

    const [destinatario, setDestinatario] = useState({ name: "", email: "" });
    const [stateImplicado, setStateImplicado] = useState("");
    const [implicados, setImplicados] = useState([]);
    const [ultimoHito, setUltimoHito] = useState("");
    const [fechaHito, setFechaHito] = useState("");
    const [codClasCaso, setCodClasCaso] = useState("");

    const [responseData, setResponseData] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [montoCosto, setMontoCosto] = useState("");
    const [folioCartaCobro, setFolioCartaCobro] = useState("");

    const [showCarpeta, setShowCarpeta] = useState(false);
    const [showBitacora, setShowBitacora] = useState(false);
    const handleCloseCarpeta = () => setShowCarpeta(false);
    const handleCloseBitacora = () => setShowBitacora(false);
    
    const [ciaImplicado, setCiaImplicado] = useState("");

    useEffect(() => {     
        dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":0,"idOrgCaso":idOrgCaso}));    
    }, [dispatch])

    useEffect(() => {
        getCfgForm();
        getImplicados();
    }, [])

    useEffect(() => {
        formik.resetForm();

        //if (stateImplicado !== "") getGestionImplicado();
        //else { setUltimoHito(""); setFechaHito("") }
        getGestionImplicado();
    }, [stateImplicado])

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: idOrgCaso, idform: 58 })).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const getImplicados = async () => {
        setLoading(true);
        const query = Buffer.from(JSON.stringify({ idOrgCaso: idOrgCaso, idCaso: idCaso })).toString('base64');
        const response = await serviceGetImplicados(query);
        setLoading(false);

        setImplicados(response);
        if (response && response.length === 1) setStateImplicado(response[0]?.IdImplicado);
    }

    const getGestionImplicado = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado: stateImplicado ? stateImplicado : 0 })).toString('base64');
        const response = await serviceGetGestionImplicado(query);

        setUltimoHito(response[0]?.ultimoHitoCaso);
        setFechaHito(response[0]?.fechaUltimoHitoFormat);
        setCodClasCaso(response[0]?.codClasCaso);
        //setFolioCartaCobro(response[0]?.folioCartaCobroDef);
    }

    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) { formik.resetForm(); fileRef.current.value = ""; goAreaTrabajo() }
    }

    const validateMontoMoneda = (value, action) => {
        let monto = 0;
        
        if (action === 'format') monto = formatoMonto(value);
        else {
            if (Number(formik.values.moneda) === 30001) monto = resetFormatoMontoSinPunto(value);
            else monto = resetFormatoMonto(value);
        }

        return monto;
    }

    const goAreaTrabajo = () => { history('/area-trabajo-recupero-companias', { state: { queryState } }) };

    const postRecepcionar = async (data) => {
        setLoading(true)
        const response = await serviceRecepcionar(data);

        setResponseData(response);
        setLoading(false);
        setShowToast(true);
    }

    const formik = useFormik({
        initialValues: {
            idCompaniaIM: "",
            idSiniestroIM: "",
            fechaSiniestroIM: "",
            fechaCarta: "",
            moneda: "",
            montoCosto: "",
            porcConvenio: "",
            montoRecobro: "",
            file: "",
            companiaIM:"",
            tipoSiniestroIM:""
        },
        validationSchema: validationSchemasRecuperacionCobro(folioCartaCobro),
        onSubmit: async (data) => {
            let dataResult = { ...data };

            dataResult.idCaso = idCaso;
            dataResult.idOrganizacion = idOrgCaso;
            dataResult.idImplicadoCaso = stateImplicado;
            dataResult.idUsuario = rutUsuario;
            dataResult.destinatarioCia = destinatario.name;
            dataResult.emailDestinatario = destinatario.email;

            dataResult.montoCosto = Number(validateMontoMoneda(data.montoCosto, 'reset_format'));
            dataResult.montoRecobro = Number(validateMontoMoneda(data.montoRecobro, 'reset_format'));

            dataResult.fechaCarta = data.fechaCarta.split('-').join('');
            dataResult.fechaSiniestroIM = data.fechaSiniestroIM.split('-').join('');
            dataResult.companiaIM = ciaImplicado;

            if (data.file) {
                getBase64(data.file).then((base64data) => {
                    const fileData = base64data.split(',')[1]
                    dataResult = { ...dataResult, "filename": data.file.name, "mimetype": data.file.type, "base64data": fileData };

                    postRecepcionar(dataResult);
                })
            } else {
                postRecepcionar(dataResult);
            }
        }
    })

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Form onSubmit={formik.handleSubmit} className='mt-2 mb-4'>
                <Card>
                    <Card.Header as='h6' style={{ backgroundColor: "#4F517A", color: '#FFFFFF' }}>
                        {cfg_form && cfg_form["recepcionacartacobrotercero-title"]}
                    </Card.Header>

                    <Card.Body>
                        <Container>
                            <Row>
                                <Col md='5'>
                                    <Form.Label className="label is_required">
                                        {cfg_form && cfg_form["recepcionacartacobrotercero-cmb-implicados"]}
                                    </Form.Label>
                                    <Form.Select
                                        name='stateImplicado'
                                        onChange={(e) => setStateImplicado(e.target.value)}
                                        value={stateImplicado}>

                                        <option value={'0'}>Seleccione...</option>
                                        {implicados && implicados
                                            .map((i) => (<option key={i.IdImplicado} value={i.IdImplicado}>{i.NombreImplicadoCmb}</option>))
                                        }
                                    </Form.Select>
                                </Col>
                                <Col md="1">
                                    <Form.Label className='label' style={{ color: 'white' }}>-</Form.Label>{' '}<br />
                                    <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Recargar Implicados </Tooltip>}>
                                        <Button type="button" style={{ float: 'left', backgroundColor: 'white', color: 'black' }} variant="outline-secondary" size="sm" onClick={() => getImplicados()}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                            </svg>
                                        </Button>
                                    </OverlayTrigger>
                                </Col>
                                <Col md='3' >
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["recepcionacartacobrotercero-lbl-ultimohito"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {ultimoHito && ultimoHito}
                                    </Form.Text>
                                </Col>
                                <Col md='3'>
                                    <Form.Label className='label'>
                                        Fecha Hito
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {fechaHito && fechaHito}
                                    </Form.Text>
                                </Col>
                            </Row>
                        </Container>

                        {stateImplicado !== "" && <CartaCobro
                            cfg_form={cfg_form}
                            formik={formik}
                            idCaso={idCaso}
                            implicado={stateImplicado}
                            codClasCaso={codClasCaso}
                            setDestNameEmail={setDestinatario}
                            fileRef={fileRef}
                            setMontoCosto={setMontoCosto}
                            responseData={responseData}
                            setCiaImplicado={setCiaImplicado}
                            folioCartaCobro={folioCartaCobro}
                            setFolioCartaCobro={setFolioCartaCobro}
                        />}
                    </Card.Body>
                    {showToast && 
                        <Mensajes
                            showToast={showToast}
                            handleCloseToast={handleCloseToast}
                            delay={5000}
                            responseData={responseData}
                        ></Mensajes>
                    }
                    <Card.Footer style={{ display: 'flex', justifyContent: 'right' }}>
                        <Button className='m-2' variant='outline-info' onClick={goAreaTrabajo}>
                            {cfg_form && cfg_form["recepcionacartacobrotercero-btn-volver"]}
                        </Button>
                        <Button className='m-2' variant='carpeta' onClick={() => setShowCarpeta(true)}>
                            {cfg_form && cfg_form["recepcionacartacobrotercero-btn-carpeta"]}
                        </Button>
                        <Button className='m-2' variant='bitacora' onClick={() => setShowBitacora(true)}>
                            {cfg_form && cfg_form["recepcionacartacobrotercero-btn-bitacora"]}
                        </Button>
                        <Button type="submit" className='m-2' variant='actualizar'>
                            {cfg_form && cfg_form["recepcionacartacobrotercero-btn-recepcionar"]}
                        </Button>
                    </Card.Footer>
                </Card>
            </Form>

            <BitacoraGestion
                handleCloseBitacora={handleCloseBitacora}
                showBitacora={showBitacora}
            />

            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
                <CarpetaDigitalComponent
                    handleClose={handleCloseCarpeta}
                    idCaso={idCaso}
                    idOrganizacionCaso={idOrgCaso}
                    idImplicado={stateImplicado}
                    prototipo={2}
                />
            </Modal>

            <style type='text/css'>
                {`
                    .is_required:after {
                        content: "*";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .btn-carpeta {
                        background-color: #D59B49;
                        color: #FFFFFF;
                        width: 140px;
                    }
                    .btn-carpeta:hover {
                        background-color:#e1b97f;
                        color: #FFFFFF;
                    }
                    .btn-bitacora {
                        background-color: #55B2CE;
                        color: #FFFFFF;
                        width: 140px;
                    }
                    .btn-bitacora:hover{
                        background-color: #87c9dc;
                        color: #FFFFFF;
                    } 
                    .btn-carta {
                        background-color:  #2E6EA5;
                        color: #FFFFFF;
                        width: 140px;     
                        padding:6px 0px 6px 0px;
                    }
                    .btn-carta:hover{
                        background-color:  #5b9ad1;
                        color: #FFFFFF;
                    }
                    .btn-actualizar {
                        background-color: #C14B49;
                        color: #FFFFFF;
                        width: 140px;
                    }
                    .btn-actualizar:hover{
                        background-color: #d3807f;
                        color: #FFFFFF;
                    }
                    .btn-volver {
                        color: #66CCCC;
                        border: 1px solid #C00
                        width: 140px;
                    }
                    .btn-tamano{
                        padding: 1rem 1.5rem;
                        font-size: 1.5rem;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default FormPrincipal;